import { Skeleton, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useGetVehicleOrdersQuery } from '../../../redux/rtk/orders.services';
import { currentUserCompanyId } from '../../../redux/selectors/userDataSelectors';
import {
  allOrdersSortEnabled,
  allOrdersSortBy,
  allOrdersSortField,
} from '../../../redux/selectors/workQueue/allOrdersSelectors';
import {
  ORDERS_VIEW,
  useViewOrdersOrVehicle,
} from '../ViewOrdersOrVehicle.provider';
import { BODY_BUILDER_BY_TAB, SELECTORS_BY_TAB } from './utils';

const getIsLoading = (isLoading, isLoadingVehicle, isFetchingVehicle) => {
  return isLoading || isLoadingVehicle || isFetchingVehicle;
};

const getTotalItems = (view, totalWorkOrders, data, hasBodyBuilder) => {
  return (
    ((view === ORDERS_VIEW || !hasBodyBuilder) && totalWorkOrders) ||
    data?.pagination?.totalResults
  );
};

const FilterWoCount = ({ totalWorkOrders, isLoading, tab, searchQuery }) => {
  const { t } = useTranslation('orders');
  const { view } = useViewOrdersOrVehicle();
  const companyId = useSelector(currentUserCompanyId);
  const sortEnabled = useSelector(allOrdersSortEnabled) || false;

  const sortColumnField = useSelector(allOrdersSortField);
  const sortColumnBy = useSelector(allOrdersSortBy);
  const selector = SELECTORS_BY_TAB[tab]?.body(companyId) || (() => null);
  const bodyBuilder = BODY_BUILDER_BY_TAB[tab] || (() => null);
  const filters = useSelector(selector);
  const {
    data,
    isFetching: isFetchingVehicle,
    isLoading: isLoadingVehicle,
  } = useGetVehicleOrdersQuery(
    bodyBuilder(
      companyId,
      1,
      filters,
      searchQuery,
      sortEnabled,
      sortColumnBy,
      sortColumnField
    ),
    { skip: !BODY_BUILDER_BY_TAB[tab] || view === ORDERS_VIEW }
  );

  const totalItems = getTotalItems(
    view,
    totalWorkOrders,
    data,
    !!BODY_BUILDER_BY_TAB[tab]
  );

  const isLoadingOrFetching = getIsLoading(
    isLoading,
    isLoadingVehicle,
    isFetchingVehicle
  );

  const suffix = t(
    ((view === ORDERS_VIEW || !BODY_BUILDER_BY_TAB[tab]) && 'title') ||
      'vehicles'
  );

  return isLoadingOrFetching ? (
    <Skeleton variant="text" sx={{ fontSize: '1rem' }} width={140} />
  ) : (
    <Typography
      variant="overline"
      sx={{ whiteSpace: 'nowrap' }}
      alignSelf="center"
    >
      {[totalItems, suffix].filter(x => x).join(' ')}
    </Typography>
  );
};

export default FilterWoCount;
